export const transpileAuthData = (data, currentState) => {
    const {
        show_set_password,
        agreement_uuid,
        show_terms_and_condition,
        userUUID,
        permissions,
        email,
        firstName,
        lastName,
        phoneNumber,
        account_uuid,
        mocked
    } = data;
    const userData = {
        showSetPassword: !!show_set_password ? show_set_password : currentState.showSetPassword,
        showTermsAndConditions: !!show_terms_and_condition ? show_terms_and_condition : currentState.showTermsAndConditions,
        agreementUUID: !!agreement_uuid ? agreement_uuid : currentState.agreementUUID,
        userUUID: !!userUUID ? userUUID : currentState.userUUID,
        permissions: !!permissions ? permissions : currentState.permissions,
        permissionsReceived: !!permissions,
        userEmail: !!email ? email : currentState.userEmail,
        userFirstName: !!firstName ? firstName : currentState.userFirstName,
        userLastName: !!lastName ? lastName : currentState.userLastName,
        userPhoneNumber: !!phoneNumber ? phoneNumber : currentState.userPhoneNumber
    };
    const accountData =  !account_uuid ? {} : {
        accountUUID: account_uuid,
        isSignedIn: !!account_uuid && !!userUUID,
        mocked: !!mocked ? mocked : false,
    };
    return { ...userData, ...accountData};
};
